import { render, staticRenderFns } from "./DataPesertaRpl.vue?vue&type=template&id=580d642e&scoped=true&"
import script from "./DataPesertaRpl.vue?vue&type=script&lang=js&"
export * from "./DataPesertaRpl.vue?vue&type=script&lang=js&"
import style0 from "./DataPesertaRpl.vue?vue&type=style&index=0&id=580d642e&scoped=true&lang=css&"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580d642e",
  null
  
)

export default component.exports